<template>
  <div>
    <div class="sc-vehicle-reg-container">
      <div class="sc-vehicle-reg-add-data-later">
        {{ $t('vehicle_registration.give_details_later') }}
      </div>
      <div>

        <sc-card v-for="(details, index) of vehicleDetailsList" class="sc-vehicle-reg-card sc-box-shadow" :key="index">
          <div slot="content" class="sc-vehicle-reg-content-container" v-on:click="onClickDetails(details.id)">
            <div class="sc-vehicle-reg-details-and-vehicle-icon">
              <i
                class="sc-vehicle-reg-vehicle-icon"
                :class="[{ 'sc-vehicle-reg-filled-vehicle-icon': details.isFilled() }, VehicleIcons[details.groupCode]]"/>
              <div v-if="details.isFilled()">
                <div
                  class="sc-vehicle-reg-make-type-licence">
                    {{ $t('vehicle_registration.make_type_licence_plate', {
                      vehicleBrand: details.vehicleBrand ? details.vehicleBrand : $t('vehicle_registration.missing_vehicle_data'),
                      vehicleType: details.vehicleType ? details.vehicleType : $t('vehicle_registration.missing_vehicle_data'),
                      licencePlate: details.licencePlate ? details.licencePlate : $t('vehicle_registration.missing_vehicle_licence_plate') })
                    }}
                </div>
                <div class="sc-vehicle-reg-package-details">
                  <div class="sc-vehicle-reg-package">
                    {{
                      $t('vehicle_registration.selected_package', {
                        package: $t('vehicle_registration.package')
                      })
                    }}
                  </div>
                  <div>
                    {{ $t('vehicle_registration.vehicle_type_and_package', {
                      vehicleType: $t(VehicleGroupLabels[details.groupCode]),
                      package: details.packageCode ? $t(PackageNameLabels[details.packageCode]) : $t('vehicle_registration.missing_vehicle_data') })
                    }}
                  </div>
                </div>
              </div>
              <div
                v-else
                class="sc-vehicle-reg-unfilled-position-vehicle-type">
                  {{ $t('vehicle_registration.position_vehicle_type', {
                    position: getPositionOfVehicleInGroup(details),
                    vehicleType: $t(VehicleGroupLabels[details.groupCode]) })
                  }}
              </div>
            </div>
            <div class="sc-vehicle-reg-add-data">
              <i
                class="sc-vehicle-reg-add-icon"
                :class="{ 'sc-icon-edit': details.isFilled(), 'sc-icon-plus': !details.isFilled() }"/>
              <div class="sc-vehicle-reg-details-button">
                {{ $t(details.isFilled() ? 'vehicle_registration.edit' : 'vehicle_registration.give_details') }}
              </div>
            </div>
          </div>
        </sc-card>

      </div>
      <div class="sc-vehicle-nav-buttons">
        <div class="sc-vehicle-reg-back-button">
          <rounded-button color="outline" @click="onBack">
              <span>{{ $t('common.back') }}</span>
          </rounded-button>
        </div>
        <div class="sc-vehicle-reg-next-button">
          <rounded-button color="primary" @click="onNext">
              <span>{{ $t('common.next') }}</span>
          </rounded-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ScCard } from 'smartcommerce-component-library'
import { Routes } from '../../utils/Routes'
import { PackageNameLabels, VehicleGroupLabels } from '@/shared/utils/Labels'
import { VehicleIcons } from '@/shared/utils/VehicleIcons'
import { VehicleRegisterAction } from '@/order-wizard/utils/VehicleRegisterAction'
import RoundedButton from '../../../shared/components/RoundedButton'

export default {
  name: 'ScRegisteredVehicleList',
  components: {
    ScCard,
    RoundedButton
  },
  data () {
    return {
      PackageNameLabels,
      VehicleGroupLabels,
      VehicleIcons
    }
  },
  methods: {
    onNext () {
      this.$router.push(Routes.CONTRACT_INPUT.path)
    },
    onBack () {
      this.$router.push(Routes.defaultPackageSelector())
    },
    onClickDetails (id) {
      this.$emit(VehicleRegisterAction.SelectedVehicleDetailsIndex, id)
    },
    getPositionOfVehicleInGroup (details) {
      return this.$store.getters.getIndexOfVehicleInGroup(details) + 1
    }
  },
  computed: {
    vehicleDetailsList: {
      get () {
        return this.$store.getters.getVehiclesInCart()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-vehicle-reg-header {
  font-size: 35px;
  font-weight: 800;
  line-height: 1.17;
  letter-spacing: 3.33px;
  margin: 50px 0px;
  color: #3b444f;
}
.sc-vehicle-reg-content-container {
  display: flex;
  justify-content: space-between;
}
.sc-vehicle-reg-container {
  margin: auto;
}
.sc-vehicle-reg-icon-type {
  display: inline-flex;
}
.sc-vehicle-reg-details-and-vehicle-icon {
  display: inline-flex;
}
.sc-vehicle-reg-add-data-later {
  font-weight: 500;
  text-align: left;
  margin: 12px 0px 15px 0px;
  font-size: 16px;
}
.sc-vehicle-reg-add-data {
  align-items: center;
  display: inline-flex;
  color: $sc-primary;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    .sc-vehicle-reg-details-button {
      text-decoration: underline;
    }
  }
}
.sc-vehicle-reg-details-button {
  height: 100%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sc-vehicle-reg-vehicle-icon {
  margin-right: 16px;
  font-size: 30px;
  opacity: 0.4;
  display: flex;
  justify-content: center;
}
.sc-vehicle-reg-filled-vehicle-icon {
  color: #2196f3;
}
.sc-vehicle-reg-unfilled-position-vehicle-type {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  opacity: 0.4;
}
.sc-vehicle-reg-card {
  padding: 15px 6px;
  margin: 10px 0px;
  width: 100%;
}
.sc-vehicle-reg-add-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.sc-vehicle-nav-buttons {
  margin: 32px 0px;
  display: flex;
}
.sc-vehicle-reg-back-button {
  width: 50%;
  text-align: left;
  margin-right: 5%;
}
.sc-vehicle-reg-next-button {
  width: 50%;

  button {
    margin-left: auto;
  }
}
.sc-vehicle-reg-make-type-licence {
  font-size: 18px;
  font-weight: bold;
}
.sc-vehicle-reg-package-details {
  display: flex;
  font-size: 14px;
}
.sc-vehicle-reg-package {
  opacity: 0.4;
  margin-right: 5px;
}

@media(max-width: 768px) {
  .sc-vehicle-reg-add-data{
    display: none;
  }
  .sc-vehicle-reg-back-button button, .sc-vehicle-reg-next-button button{
    min-width: inherit;
    width: 100%;
  }
}
</style>
